import { gql } from "@apollo/client";
import { EnforcementIntentDetail } from "../fragments";
import { EnforcementIntentSummary, enforcementIntentSummaryFragment } from "../fragments/enforcementIntentSummary";

export const REVIEW_ENFORCEMENT_INTENT = gql`
  mutation ReviewEnforcementIntent(
    $intentId: uuid!
    $approve: Boolean!
    $deniedReason: String
    $selectedEnforcementPolicyId: uuid
    $operatorAccountId: uuid
  ) {
    review_enforcement_intent(
      enforcement_intent_id: $intentId
      approve: $approve
      denied_reason: $deniedReason
      selected_enforcement_policy_id: $selectedEnforcementPolicyId
      operator_account_id: $operatorAccountId
    ) {
      enforcement_intent {
        ...enforcementIntentSummaryFragment
        voidedReason: voided_reason
        noticeIndex: notice_index
        roLookupStatus: ro_lookup_status
        roLookupSubmittedAt: ro_lookup_submitted_at
        roLookupCompletedAt: ro_lookup_completed_at
        initialLetterRequestedAt: initial_letter_requested_at
        initialLetterSentAt: initial_letter_sent_at
        dueAt: due_at
        officerBadgeId: officer_badge_id
        officerName: officer_name
      }
    }
  }
  ${enforcementIntentSummaryFragment}
`;

export interface ReviewEnforcementIntentData {
  review_enforcement_intent: {
    enforcement_intent: ReviewedEnforcementIntent;
  };
}

export interface ReviewedEnforcementIntent extends EnforcementIntentSummary {
  voidedAt: string | null;
  noticeIndex: number;
  roLookupStatus: EnforcementIntentDetail["roLookupStatus"];
  roLookupSubmittedAt: EnforcementIntentDetail["roLookupSubmittedAt"];
  roLookupCompletedAt: EnforcementIntentDetail["roLookupCompletedAt"];
  initialLetterRequestedAt: EnforcementIntentDetail["initialLetterRequestedAt"];
  initialLetterSentAt: EnforcementIntentDetail["initialLetterSentAt"];
  dueAt: EnforcementIntentDetail["dueAt"];
  officerBadgeId: EnforcementIntentDetail["officerBadgeId"];
  officerName: EnforcementIntentDetail["officerName"];
}

export type ReviewEnforcementIntentVars = ApproveEnforcementIntentVars | DenyEnforcementIntentVars;

export interface ApproveEnforcementIntentVars {
  intentId: string;
  approve: true;
  deniedReason?: never;
  selectedEnforcementPolicyId?: string;
  /**
   * Fleet operator assigned during review (AUT-5032). One-time: the citation's
   * session transaction is re-billed to this account when the intent is issued.
   */
  operatorAccountId?: string;
}

export interface DenyEnforcementIntentVars {
  intentId: string;
  approve: false;
  deniedReason: string;
}

export default REVIEW_ENFORCEMENT_INTENT;
